module.exports = __webpack_public_path__ + "static/media/startbild_sw_mit_flasche.d8b5b8a9.jpg";